import { useEffect, useState } from "react";
import * as workflowService from "../services/workflowService";

// Whether the Tasks menu is offered: only once workflows are actually in use for this
// person, so a business that never sets one up sees nothing new. Fetched once per page
// load (the useSkills pattern); a failure is not remembered and means "not offered".
let cached = null;
let inflight = null;

const fetchOnce = () => {
  if (cached !== null) return Promise.resolve(cached);
  if (!inflight) {
    inflight = workflowService
      .getWorkflowAccess()
      .then((res) => {
        if (res?.success) cached = !!res.data?.enabled;
        return !!cached;
      })
      .catch(() => false)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

// Test hook: forget what was fetched.
export const resetWorkflowAccessCache = () => {
  cached = null;
  inflight = null;
};

// `enabled` false (for example a Super Admin, who has no vendor) never calls the API.
export default function useWorkflowAccess(enabled = true) {
  const [on, setOn] = useState(cached === true);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    fetchOnce().then((value) => {
      if (!cancelled) setOn(value);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return on;
}
